import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  avatars: [],
  gender: [],
  loading: false,
  error: null,
  isSucess: false,
  createUserSuccess: false,
};

export const createUserSlice = createSlice({
  name: "createUser",
  initialState,
  reducers: {
    createUserLoad: (state) => {
      state.loading = true;
      state.isSucess = false;
    },
    createUserSuccess: (state, action) => {
      state.loading = false;
      state.isSucess = action.payload;
    },
    createUserFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    avatarListLoad: (state) => {
      state.loading = true;
    },
    avatarListSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.avatars = action.payload;
    },
    genderListLoad: (state) => {
      state.loading = true;
    },
    genderListSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.gender = action.payload;
    },

    dummyUserListLoad: (state) => {
      state.loading = true;
    },
    dummyUserListSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.gender = action.payload;
    },
  },
});

export const {
  createUserLoad,
  createUserSuccess,
  createUserFailure,
  avatarListLoad,
  avatarListSuccess,
  genderListLoad,
  genderListSuccess,
  dummyUserListLoad,
  dummyUserListSuccess,
} = createUserSlice.actions;
export default createUserSlice.reducer;
